import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import styles from './styles.module.scss'

function PendingInvites({}) {
  const { t } = useTranslation()

  const {
    myhome: {
      all: { group_invitations }
      // invitations: { list, loading }
    },
    common: { isMobile, isNative, isTablet }
    // organization: { current_organization }
  } = useSelector((state) => state)

  return (
    <section className={styles.pendingInvitesContainer} tabIndex={0} aria-label={t('myhome.mygroups.pendingGroups')}>
      {group_invitations.invites &&
        group_invitations.invites.length > 0 &&
        group_invitations.invites.map((g) => {
          let bgStyle = {}
          if (g.cover_picture) {
            bgStyle = {
              backgroundImage: `url(${g.cover_picture})`,
              backgroundColor: 'rgba(2, 1, 5, 0.3)',
              backgroundSize: 'cover'
            }
          }
          return (
            <button
              aria-label={t('homePendingInvites.groupInviteFor', { groupName: g.group_title })}
              key={g.group_id}
              className={`${styles.card} ${styles.groupContainer}`}
              onClick={() => redirectToPage(`/0/home/group/${g.group_id}`, isNative, true)}>
              <div className={styles.groupCard} style={bgStyle}>
                <div className={styles.content}>
                  <h1 className={styles.title}>{t('homePendingInvites.groupInvite')}</h1>
                  <h2 className={styles.name}>{g.group_title}</h2>
                </div>
                <button
                  className={styles.button}
                  title={t('homePendingInvites.joinGroup')}
                  onClick={() => redirectToPage(`/0/home/group/${g.group_id}`, isNative, true)}>
                  <Icon name='arrow-right' />
                </button>
              </div>
            </button>
          )
        })}
    </section>
  )
}

export default PendingInvites
